/* eslint-disable prettier/prettier */
import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

export const CollaborateWrapper = styled.div`
	min-height: 300px;
	max-height: fit-content;
	box-sizing: border-box;
	width: 100%;
	.content {
		height: 100%;
		padding: 120px 0px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		.left-section {
			width: 55%;
			height: 100%;
			margin-right: 20px;
			display: flex;
			flex-direction: column;
			align-items: start;
			justify-content: space-between;
			.title {
				color: ${colors.dark};
				font-size: 2.8rem;
				font-family: 'Segnifier-Regular';
				margin: 0;
				margin-bottom: 24px;
			}
		}
		.right-section {
			width: 40%;
			.sub-title {
				font-size: 1.25rem;
				line-height: 2rem;
				color: ${colors.textDark};
			}
		}
	}
	@media ${device.tablet} {
		.content {
			padding: 20px;
		}
	}

	@media ${device.mobile} {
		.content {
			flex-direction: column;
			padding: 20px;
			.left-section {
				width: 100%;
				margin-right: 0;
				.title {
					font-size: 2.5rem;
					margin-bottom: 30px;
				}
			}
			.right-section {
				width: 100%;
				.sub-title {
					margin-top: 30px;
					font-size: 1.2rem;
					line-height: 1.5rem;
					color: ${colors.textDark};
				}
			}
		}
	}
`;
